import {get, post, postJson,put} from './axios'



// 1支付宝红包，3优惠券
export const getPrize = p => postJson(`/prize/list`, p);

export const getMember = p => get(`/member/center/level`, p);

export const addLevel = p => postJson(`/member/center/addLevel`, p);

export const editLevel = p => put(`/member/center/level`, p);

export const pointRuleConfig = p => postJson(`/member/center/pointRuleConfig`, p);

/***
 * 首页 买家信息 短信软件剩余天数
 * @param p
 */
export const getSoftwareInfo = p => get(`/taohd/current`, p)

// 积分设置
export const getPointRuleConfig = p => get(`/member/center/getPointRuleConfig`, p);

export const getActivityCount = p => postJson(`/member/center/activity/count`, p);

// 开卡
export const updateMemberCenterURL = (p) => get(`/decorationInfo/open/card`, p);

// 开卡
export const taohdName = (p) =>post(`/taohd/mini-app-name`, p);

// 入会门槛修改
export const saveLevelRuleTask = (p) =>postJson(`/member/center/saveLevelRuleTask`, p);

// 入会门槛查询
export const getLevelRuleTask = () =>get(`/member/center/getLevelRuleTask`);

// 专属下单商品列表
export const getSpecialGoods = (p) =>postJson(`/special-items-info/list`, p);
